import WOW from 'wowjs';

export default {
  init() {
    // JavaScript to be fired on the Vets Advocacy page

    // Timeline Slider
    $('.timeline-slider').slick({
      autoplay: false,
      dots: false,
      // fade: true,
      slidesToShow: 4,
      slidesToScroll: 4,
      speed: 400,
      infinite: true,
      pauseOnHover: false,
      appendArrows: $('.arrows'),
      responsive: [
        {
          breakpoint: 768,
          settings: {
            dots: false,
            arrows: true,
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
      ],
    });

    $('.item').click(function () {
      $('.timeline-desc').removeClass('activated');

      $('.item').removeClass('activated');

      $(this).addClass('activated');

      // var timelineDesc = $(this).data('desc');
      var timelineTitle = $(this).data('title');
      var timelineLink = $(this).data('link');
      var buttonText = $(this).data('btntext');
      var buttonType = $(this).data('btntype');
      var eventDesc = $(this).find('.event-desc').html();

      $('.timeline-desc').html(
        '<div class="event-description"><h3>' +
        timelineTitle +
        '</h3><p>' +
        eventDesc +
        '</p><a href="' +
        timelineLink +
        '" target="_blank" class="btn btn-red btn-sm timeline-btn">' +
        buttonText +
        ' <i class="' +
        buttonType +
        '"></i></a></div>'
      );

      setTimeout(function () {
        $('.timeline-desc').addClass('activated');
      }, 600);
    });

    var templateUrl = '../wp-content/themes/vets';

    $(window).scroll(function () {
      var scroll = $(window).scrollTop();
      if (scroll >= 300) {
        //var slideno = $('.timeline-slider').data('slick-index', 0);
        //$('.timeline-slider').slick('slickGoTo', slideno);
        // console.log(slideno);

        // $('.timeline-slider').slick('slickGoTo', index);

        $('.timeline-slider').slick('slickGoTo', 0);
        $('.item').removeClass('slick-active');
        $('.item').removeClass('activated');

        $('.timeline-desc').html(
          '<div class="row"><div class="col-xs-12 col-sm-12 col-md-4"><figure><img src="' +
          templateUrl +
          '/dist/images/VetsAdvocacy-Shadow-Logo.png" class="img-responsive" /></figure></div><div class="col-xs-12 col-sm-12 col-md-8"><h5>Vets Advocacy is a privately funded, non-profit organization facilitating revitalization of the U.S. Department of Veterans Affairs West Los Angeles campus as a condition of the Valentini v Shinseki settlement.</h5></div></div>'
        );
      }
    });
  },
  finalize() {
    // JavaScript to be fired on the Vets Advocacy page, after page specific JS is fired
    new WOW.WOW().init();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/vets_advocacy.js